import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {weakMemo} from '@packages/utilities/memo';

export type InstanceStack =
  | Readonly<{inst: ExpressionElement; tail: InstanceStack}>
  | Readonly<{inst: null}>;

/**
 * Singleton empty `InstanceStack` for memoization.
 */
export const EMPTY_INSTANCE_STACK: InstanceStack = {inst: null};

const withoutTail = weakMemo((inst: ExpressionElement) => ({
  inst,
  tail: EMPTY_INSTANCE_STACK,
}));

const withTail = weakMemo((tail: InstanceStack) =>
  weakMemo((inst: ExpressionElement): InstanceStack => ({inst, tail}))
);

/**
 * Creates a new `InstanceStack` with `inst` using `stack` as `tail`.
 */
export const push = (
  stack: InstanceStack
): ((inst: ExpressionElement) => InstanceStack) =>
  stack === EMPTY_INSTANCE_STACK ? withoutTail : withTail(stack);
